
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const BrandCenter = lazy(() => import('../pages/brand-center/page'));
const AnchorCooperation = lazy(() => import('../pages/anchor-cooperation/page'));
const FactoryCooperation = lazy(() => import('../pages/factory-cooperation/page'));
const Cooperation = lazy(() => import('../pages/cooperation/page'));
const Traceability = lazy(() => import('../pages/traceability/page'));
const About = lazy(() => import('../pages/about/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/brand-center',
    element: <BrandCenter />
  },
  {
    path: '/anchor-cooperation',
    element: <AnchorCooperation />
  },
  {
    path: '/factory-cooperation',
    element: <FactoryCooperation />
  },
  {
    path: '/cooperation',
    element: <Cooperation />
  },
  {
    path: '/traceability',
    element: <Traceability />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
